import angular from 'angular';
import async from 'async';

import {getDateRanges} from '../../common/datetime/date-ranges';
import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import template from './segmentsIndex.jade';

export class SegmentsIndexController {
  /* @ngInject */
  constructor($stateParams,
              GamesResource,
              SegmentsResource,
              SegmentPreviewResource,
              SegmentSizePreviewResource,
              currentUser,
              currentGame,
              $state,
              $filter,
              $q,
              hideThatProduct) {
    this.SegmentsResource = SegmentsResource;
    this.SegmentSizePreviewResource = SegmentSizePreviewResource;
    this.GamesResource = GamesResource;
    this.$state = $state;
    this.$q = $q;
    this.$stateParams = $stateParams;
    this.segmentTypeFilterValue = 'all';
    this.segmentStatusFilterValue = 'active';
    this.segmentNameFilterValue = '';
    this.apiDate = $filter('apiDate');
    this.hideThatProduct = hideThatProduct;
    this.truncate = $filter('truncate');
    this.segmentLogic = $filter('segmentLogic');
    this.currentGame = currentGame;

    currentUser.subscribe((user) => {
      if(user) {
        this.showEngagementSegmentToUser = !user.hasRole('SELLER_ONLY');
        this.hideAcquisitionProduct = this.hideThatProduct.hideAcquisitionProduct(user);
      }
    });

    this.newSegment = {
      game_id: $stateParams.gameId,
      definition: {},
      preview: SegmentPreviewResource
    };

    this.clonedSegment = {
      preview: SegmentPreviewResource
    };

    this.daterange = {
      startDate: getDateRanges().last30Days[0],
      endDate: getDateRanges().last30Days[1]
    };

    if ($stateParams.new) {
      this.editSegment(this.newSegment, $stateParams.type);
    }

    this.getSegments($stateParams.gameId);
    this.getCurrency();
  }

  showSegmentDesc(segment) {
    const segmentDesc = this.segmentLogic(segment)
    return segmentDesc.length <= 100 || segment.showMore ? segmentDesc : this.truncate(segmentDesc, 97, '...')
  }

  getCurrency() {
    this.GamesResource.one(this.$stateParams.gameId).get()
      .then((game) => game.getGameDeveloper())
      .then((gameDeveloper) => this.currency = gameDeveloper.currency);
  }

  getSegmentActiveCampaignsPromise(segment) {
    if (segment.status === 'active') {
      return this.SegmentsResource.one(segment.id).one('activeCampaigns').get();
    }
  }

  getSegmentSizePromise(segment) {
    if (segment.status === 'active') {
      return this.SegmentSizePreviewResource.post({
        game_id: this.$stateParams.gameId,
        segment_id: segment.id,
        definition: segment.definition
      });
    }
  }

  getSegments(gameId) {
    var self = this;
    if(this.showEngagementSegmentToUser) {
      this.SegmentsResource.getList({game_id: gameId}).then((segments) => {
        this.segments = segments;
        var queue = async.queue(function(task, callback) {
          let promises = [];
          promises.push(
              self.getSegmentSizePromise(task.segment)
                  .then((preview) => {
                    task.segment.segment_size = preview.segment_size;
                    task.segment.segmentSizeLoaded = true;
                  })
         );
          promises.push(
            self.getSegmentActiveCampaignsPromise(task.segment)
                .then((segmentWithActiveCampaigns) => {
                  task.segment.activeCampaignsSize = segmentWithActiveCampaigns.campaigns.length;
                  task.segment.activeCampaignsSizeLoaded = true;
                })
          );
          self.$q.all(promises).then(() => callback());

        }, 3);

        this.segments.forEach(segment => {
          if (segment.status === 'active') {
            queue.push({segment: segment}, function(err) {})
          }
      });
    })}
  }

  editSegment(segment, segmentType) {
    this.newSegment.newAndPristine = true;
    this.newSegment.type = segmentType;
    this.newSegment.editing = false;
    this.newSegment.name = 'New Engagement Segment';
    _.without((this.segments||[]), segment).forEach(segment => segment.editing = false);
    segment.editing = !segment.editing;
  }

  setEditedSegment(segment) {
    _.without((this.segments||[]), segment).forEach(segment => segment.editing = false);
    segment.editing = !segment.editing;
  }

  cloneSegment(segment) {
    let clonedSegment = _.cloneDeep(segment);
    delete clonedSegment.id;
    delete clonedSegment.created_at;
    delete clonedSegment.updated_at;
    clonedSegment.newAndPristine = true;
    clonedSegment.name = 'copy_of ' + segment.name;
    this.clonedSegment = clonedSegment;
    this.clonedSegment.editing = true;
  }

  getOffsetForNewSegmentEdit() {
    return  this.newSegment.type === "engagement" ? '-344px' : '-388px';
  }
}

export function SegmentsIndexComponent(){
  return{
    restrict: 'E',
    template,
    controller: SegmentsIndexController,
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
}

export default angular.module('app.components.segments.index', [
  ResourcesModule.name,
  ServicesModule.name
])
  .directive('segmentsIndex', SegmentsIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsIndex.js
 **/